import { memo, useRef } from 'react';

import MiddleEllipsis from 'react-middle-ellipsis';

import { cn } from '@/shadcn/lib/utils';

import { useMeasure } from '@/utils/hooks';

export type Props = {
  /** The text to crop. */
  text?: string;
  /**
   * Whether to crop the text from the middle of the string.
   * @default false
   */
  middleEllipsis?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const TextEllipsis = memo(
  ({ text = '', className, middleEllipsis = false, ...props }: Props) => {
    const containerRef = useRef();
    const [measureRef, bounds] = useMeasure(containerRef, 0);

    if (!middleEllipsis) {
      return (
        <div className={cn('truncate', className)} {...props}>
          {text}
        </div>
      );
    }

    return (
      <div className={cn('truncate', className)} ref={measureRef} {...props}>
        <MiddleEllipsis width={bounds.width}>
          <span>{text}</span>
        </MiddleEllipsis>
      </div>
    );
  }
);
